import Splide from "@splidejs/splide";

export { Splide };
